// extracted by mini-css-extract-plugin
export default {"messagesSectionMobileFooterContainer":"MessagesSectionMobileFooter_messagesSectionMobileFooterContainer__4x08j"};